import { useEffect } from 'react';

import { useStores } from '../../../../stores/useStores';

export function usePocProcess(isCurrent: boolean) {
  const { pocStore } = useStores();

  useEffect(() => {
    if (isCurrent) {
      pocStore.setUserIsPerformingPoc(true);
    }

    return () => {
      if (isCurrent) {
        pocStore.setUserIsPerformingPoc(false);
      }
    };
  }, [pocStore, isCurrent]);
}
